export type GoustoHeadersValueProvider = () => {
  authUserId: string | null
  authToken: string | null
  experimentationUserId: string | null
  deviceId: string | null
}

let valueProvider: GoustoHeadersValueProvider | null = null

export function getGoustoHeadersValues(): ReturnType<GoustoHeadersValueProvider> {
  return (
    valueProvider?.() ?? {
      authUserId: null,
      authToken: null,
      experimentationUserId: null,
      deviceId: null,
    }
  )
}

export function setGoustoHeadersValueProvider(provider: GoustoHeadersValueProvider | null) {
  valueProvider = provider
}
